import { createAxiosClient } from "@ntg/component-library/utilities";
import { useQuery } from "@tanstack/react-query";

export interface ICustomerPaymentD365 {
    accountNum: string;
    amountCur: number;
    companyBankAccountId: string;
    createdBy1: string;
    currencyCode: string;
    dataAreaId: string;
    exchRate: number;
    sheaSalesId: string;
    transDate: string;
    voucher: string;
}

const getCustomerPaymentsByCoOrderD365 = async (
    coOrderID: string,
): Promise<ICustomerPaymentD365[]> => {
    const axiosAuth = createAxiosClient("D365FO");
    const response = await axiosAuth.get<ICustomerPaymentD365[]>(
        `/CustomerPayments/GetCoOrderPayments/${encodeURIComponent(coOrderID)}`,
    );
    return response.data;
};

export const useGetCustomerPaymentsByCoOrderD365 = (coOrderID: string | undefined) => {
    return useQuery<ICustomerPaymentD365[]>({
        queryKey: ["GetCustomerPaymentsByCoOrderD365", coOrderID ?? null],
        queryFn: () => {
            if (!coOrderID?.trim()) {
                throw new Error("Invalid params for GetCustomerPaymentsByCoOrderD365");
            }
            return getCustomerPaymentsByCoOrderD365(coOrderID);
        },
        enabled: Boolean(coOrderID?.trim()),
        refetchOnWindowFocus: false,
        retry: false,
    });
};
